<template>
  <div>
    <div class="ts-space-y-3">
      <div class="row">
        <div class="col-md-6 ts-space-y-3">
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-font-robot">{{
                $t('projectProfile.code')
              }}</label>
              <input
                v-model="model.project_code"
                type="text"
                class="form-control"
                placeholder="Input project code. ex: 0000-000"
              />
              <div class="validate" v-if="errors.has('project_code')">
                {{ errors.first('project_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-font-robot">{{
                $t('projectProfile.name')
              }}</label>
              <input
                v-model="model.project_name"
                type="text"
                class="form-control"
                placeholder="Input project name. ex: UX/UI Design"
              />
              <div class="validate" v-if="errors.has('project_name')">
                {{ errors.first('project_name') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-font-robot">{{
                $t('projectProfile.status')
              }}</label>
              <a-select
                v-model="model.status_id"
                :options="projectStatus"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                class="ts-w-full"
                placeholder="Select who is main response"
              ></a-select>
              <div class="validate" v-if="errors.has('status_id')">
                {{ errors.first('status_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-font-robot">{{
                $t('projectProfile.owner')
              }}</label>
              <a-select
                v-model="model.project_owner"
                :options="owners"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                class="ts-w-full"
                placeholder="Select who is main response"
              ></a-select>
              <div class="validate" v-if="errors.has('project_owner')">
                {{ errors.first('project_owner') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-font-robot">{{
                $t('projectProfile.estimated')
              }}</label>
              <a-range-picker
                v-model="model.estimated_date"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                class="ts-w-full"
              />
              <div class="validate" v-if="errors.has('estimated_date')">
                {{ errors.first('estimated_date') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-font-robot ts-capitalize">{{
                $t('projectProfile.actual')
              }}</label>
              <a-range-picker
                v-model="model.actual_date"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                class="ts-w-full"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-3">
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-font-robot">{{
                $t('projectProfile.customer')
              }}</label>
              <a-select
                v-model="model.customer_id"
                :options="customers"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                class="ts-w-full"
                placeholder="Select customer name"
              ></a-select>
              <div class="validate" v-if="errors.has('customer_id')">
                {{ errors.first('customer_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-font-robot">{{
                $t('projectProfile.member')
              }}</label>
              <a-select
                v-model="model.project_member"
                mode="multiple"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :options="owners"
                class="ts-w-full"
                placeholder="Select who will be involve"
              ></a-select>
              <div class="validate" v-if="errors.has('project_member')">
                {{ errors.first('project_member') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-font-robot">{{
                $t('projectProfile.address')
              }}</label>
              <textarea
                v-model="model.project_address"
                class="form-control"
                placeholder="Describe the place of you project"
                rows="3"
              ></textarea>
              <div class="validate" v-if="errors.has('project_address')">
                {{ errors.first('project_address') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-font-robot">{{
                $t('projectProfile.description')
              }}</label>
              <textarea
                v-model="model.project_description"
                placeholder="Describe any info for project"
                class="form-control"
                rows="3"
              ></textarea>
              <div class="validate" v-if="errors.has('project_description')">
                {{ errors.first('project_description') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
        >
          <ts-button @click.prevent="$emit('cancel')"
            >{{ $t('cancel') }}
          </ts-button>
          <ts-button @click.prevent="save" color="primary">{{
            $t('save')
          }}</ts-button>
        </div>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      errors: new Errors(),
      loading: false,
      owners: [],
      customers: [],
      projectStatus: [],
      model: {
        project_id: '',
        project_code: '',
        project_name: '',
        project_address: '',
        project_owner: undefined,
        project_member: [],
        project_description: '',
        estimated_date: undefined,
        actual_date: undefined,
        customer_id: '',
        status_id: 1
      }
    }
  },
  created() {
    this.fetchViewModel()
    this.errors = new Errors()
  },
  methods: {
    ...mapActions('projectMgt/projectProfile', ['formViewModel', 'store']),
    fetchViewModel() {
      this.loading = true
      this.formViewModel()
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.customers = response.data.customer.map(el => ({
            value: el.customer_id,
            label: el.customer_name
          }))
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    save() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('project', response.project)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.project_id = ''
      this.model.project_code = ''
      this.model.project_name = ''
      this.model.project_address = ''
      this.model.project_owner = undefined
      this.model.project_member = []
      this.model.project_description = ''
      this.model.estimated_date = undefined
      this.model.actual_date = undefined
      this.model.customer_id = ''
      this.model.status_id = 1
    }
  }
}
</script>
